/**
 * Télécharge un CSV lisible par Excel : séparateur `;`, BOM UTF-8 (sans lui,
 * Excel lit les accents en Latin-1). Le fichier est nommé d'après la campagne
 * et la date du jour.
 */
export function telechargerCsv(
  campagneNom: string,
  entetes: string[],
  lignes: string[][],
): void {
  const contenu = [entetes, ...lignes]
    .map((ligne) =>
      ligne
        .map((cellule) =>
          cellule.includes(";") ? `"${cellule.replace(/"/g, '""')}"` : cellule,
        )
        .join(";"),
    )
    .join("\n");

  const blob = new Blob(["﻿" + contenu], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const lien = document.createElement("a");
  const date = new Date().toISOString().slice(0, 10);
  lien.href = url;
  lien.download = `${campagneNom.replace(/[^a-zA-Z0-9]/g, "_")}_${date}.csv`;
  document.body.appendChild(lien);
  lien.click();
  document.body.removeChild(lien);
  URL.revokeObjectURL(url);
}
